/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageUrls } from '../models/ImageUrls';
import type { InteriorScoreResponse } from '../models/InteriorScoreResponse';
import type { Result_AltTextResponse_ } from '../models/Result_AltTextResponse_';
import type { Result_FeatureResponse_ } from '../models/Result_FeatureResponse_';
import type { Result_RoomFunctionResponse_ } from '../models/Result_RoomFunctionResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ComputerVisionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Detect room features from images (hardwood floor, granite countertop, kitchen island, etc.)
     * Can process up to 30 image urls at a time.
     * @param requestBody
     * @returns Result_FeatureResponse_ Ok
     * @throws ApiError
     */
    public detectFeatures(
        requestBody: ImageUrls,
    ): CancelablePromise<Result_FeatureResponse_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/qualityscore/detect_features',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Detect room function from images (living room, kitchen, etc.)
     * Can process up to 30 image urls at a time.
     * @param requestBody
     * @returns Result_RoomFunctionResponse_ Ok
     * @throws ApiError
     */
    public detectRoomFunction(
        requestBody: ImageUrls,
    ): CancelablePromise<Result_RoomFunctionResponse_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/qualityscore/detect_room_function',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate alt text from images. Uses detected features and room function.
     * Can process up to 30 image urls at a time.
     * @param requestBody
     * @returns Result_AltTextResponse_ Ok
     * @throws ApiError
     */
    public generateAltText(
        requestBody: ImageUrls,
    ): CancelablePromise<Result_AltTextResponse_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/qualityscore/generate_alt_text',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Score interior images in terms of quality and condition.
     * Ranges is from 0 (disrepair) to 1 (excellent).
     * Can process up to 30 image urls at a time.
     * @param requestBody
     * @returns InteriorScoreResponse Ok
     * @throws ApiError
     */
    public scoreInterior(
        requestBody: ImageUrls,
    ): CancelablePromise<InteriorScoreResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/qualityscore/score_interior',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
